// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-text-color: #344054; 
    --second-text-color: #667085; 
    --third-text-color: #475467;
    --main-purple: #7f56d9; 
    --light-gray: #EAECF0;
    --light-border-color: #D0D5DD;
    --border-error-solid: #D92D20;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginComponents/variables.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,6BAA6B;AACjC","sourcesContent":[":root {\n    --main-text-color: #344054; \n    --second-text-color: #667085; \n    --third-text-color: #475467;\n    --main-purple: #7f56d9; \n    --light-gray: #EAECF0;\n    --light-border-color: #D0D5DD;\n    --border-error-solid: #D92D20;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
